import { render, staticRenderFns } from "./BlocklyComponent.vue?vue&type=template&id=343fca4a&scoped=true"
import script from "./BlocklyComponent.vue?vue&type=script&lang=js"
export * from "./BlocklyComponent.vue?vue&type=script&lang=js"
import style0 from "./BlocklyComponent.vue?vue&type=style&index=0&id=343fca4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343fca4a",
  null
  
)

export default component.exports